import api from "./index";

export interface TreatmentRecordPayload {
  id?: string;
  patientId: string;
  clinicId: string;
  treatmentId: string;

  isAligner: boolean;

  upperJawOption: string | null;
  lowerJawOption: string | null;
  wireChange: string | null;

  treatmentNotes: string;
  appointmentId: string | null;
}

export const createOrUpdateTreatmentRecord = (
  data: TreatmentRecordPayload,
  treatmentVisuals: File[] = []
) => {
  const formData = new FormData();
  formData.append("data", JSON.stringify(data));

  treatmentVisuals.forEach((file) => {
    formData.append("treatmentVisuals", file);
  });

  return api.post("/treatment-record/create-update", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getTreatmentRecordById = (id: string) => {
  return api.get(`/treatment-record/getOne/${id}`);
};

export interface TreatmentRecordPaginationPayload {
  curPage: number;
  perPage: number;
  sortBy: string;
  direction: "asc" | "desc" | string;
  whereClause: Array<{ key: string; value: string; operator: string }>;
}

export const paginateTreatmentRecords = (
  payload: TreatmentRecordPaginationPayload
) => {
  return api.post("/treatment-record/pagination-by-patient", payload);
};

export const deleteTreatmentRecord = (id: string) => {
  return api.get(`/treatment-record/delete/${id}`);
};

export const deleteTreatmentVisual = (id: string) => {
  return api.get(`/treatment-record/delete-visual/${id}`);
};


